export const PAGE_SIZE = 100;

// Workflow order: action-required statuses (Gaps, Pending) up front, then the
// success path, with Excluded + Push Queue at the end.
export const STATUS_TABS = [
  { val: 'all',                label: 'All' },
  { val: 'gap',                label: 'Gaps' },
  { val: 'pending',            label: 'Pending' },
  { val: 'approved',           label: 'Approved' },
  { val: 'queued',             label: 'Queued' },
  { val: 'pushed',             label: 'Synced' },
  { val: 'ops_review',         label: 'Ops Review' },
  { val: 'manually_handled',   label: 'Manually Handled' },
  { val: 'failed',             label: 'Failed' },
  { val: 'excluded_ref_data',  label: 'Excluded' },
  { val: 'push_queue',         label: 'Sync Queue' },
];

// Per-tab smart default sort. Users can override via column-click or sort dropdown.
export const TAB_DEFAULT_SORT = {
  pending:           { by: 'total_amount',           dir: 'desc' },
  gap:               { by: 'billable_hours_at_stake', dir: 'desc' },
  excluded_ref_data: { by: 'business_date',          dir: 'desc' },
  approved:          { by: 'id', dir: 'desc' },
  queued:            { by: 'id', dir: 'desc' },
  pushed:            { by: 'id', dir: 'desc' },
  failed:            { by: 'id', dir: 'desc' },
  source_deleted:    { by: 'id', dir: 'desc' },
  source_modified:   { by: 'id', dir: 'desc' },
  ops_review:        { by: 'id', dir: 'desc' },
  manually_handled:  { by: 'id', dir: 'desc' },
  all:               { by: 'id', dir: 'desc' },
};

// update-status is three user actions behind one endpoint; each maps to its
// own key in the backend's billing_records.BULK_ACTIONS (different eligible
// source statuses, different cap). Used to ask /records/bulk-preview what a
// filter-wide action would actually do.
export const BULK_ACTION_BY_STATUS = {
  approved:         'approve',
  pending:          'set_pending',
  manually_handled: 'mark_handled',
};

// Ops Review groups orphan + drift records into a single review queue.
// Sent to the API as ?status=source_deleted,source_modified.
export const OPS_REVIEW_STATUSES = ['source_deleted', 'source_modified'];

// Statuses a record can be moved to 'manually_handled' FROM. Mirrors the
// backend's billing_records.MANUALLY_HANDLED_FROM — kept in sync so the
// action bar only offers the button when every selected record is eligible.
export const MANUALLY_HANDLED_FROM = ['pending', 'source_deleted', 'source_modified'];

// Statuses a record can be manually EXCLUDED from. Mirrors the backend's
// billing_records.MANUALLY_EXCLUDED_FROM. Narrower than the handled list on
// purpose: pending + gap are the two states that provably carry no live
// NetSuite TimeBill.
export const MANUALLY_EXCLUDED_FROM = ['pending', 'gap'];

// Manual exclusions reuse status='excluded_ref_data' and are told apart by
// this exclusion_reason — which is also what the Excluded tab's reason filter
// keys on.
export const MANUALLY_EXCLUDED_REASON = 'manually_excluded';

// Human labels for where Undo Handling sent each record. The two Ops Review
// statuses collapse to one name because that's the tab the user will look at.
export const STATUS_RETURN_LABEL = {
  pending:         'Pending',
  gap:             'Gaps',
  source_deleted:  'Ops Review',
  source_modified: 'Ops Review',
};

// First-click direction when a user clicks a column header.
export const COL_DEFAULT_DIR = {
  id:                 'desc',
  business_date:      'desc',
  gross_hours:        'desc',
  total_amount:       'desc',
  gap_count:          'desc',
  is_customer_ot:     'desc',
  employee_name:      'asc',
  pay_group:          'asc',
  site_code:          'asc',
  ns_location_name:   'asc',
  billing_title_name: 'asc',
  service_item_name:  'asc',
  status:             'asc',
};
